<p-card>
  <app-loading-indicator [loading]=loading></app-loading-indicator>

  <div class="p-grid">
    <div class="p-col-6 p-md-6 p-sm-6">
      <h3 [style]="{ fontWeight: '600' }">{{ 'COOK_BOOK_STOCKS' | translate}}</h3>
    </div>
    <div class="p-col-6 p-md-6 p-sm-6">
      <app-page-info [pageName]="'COOKBOOK'"></app-page-info>
      <p-fileUpload name="file" class="p-d-inline-block" styleClass="p-button-text" chooseIcon="pi pi-upload"
                    mode="basic" [chooseLabel]="'IMPORT'| translate" #fileUpload auto="true" customUpload="true"
                    multiple="multiple" (uploadHandler)="upload($event, 'cookBook', fileUpload)">

      </p-fileUpload>
    </div>
  </div>

  <div class="p-grid">
    <div class="p-col-12" style="overflow-x: auto;">
      <div class="main-content-div">
        <div>
          <div class="main-content-div-row3">
            <div class="category-div">
              <div class="p-grid">

                <p-table [value]="cookBookStocks" [tableStyle]="{'min-width': '50rem'}" dataKey="id" editMode="row"
                         [paginator]="true" [rows]="20" [totalRecords]="total" [lazy]="true" (onLazyLoad)="load($event)"
                         [rowsPerPageOptions]="[10,25,50]">
                  <ng-template pTemplate="header">
                    <tr>
                      <th [style]="{width:'10%'}" pSortableColumn="code">
                        <p-sortIcon field="code"></p-sortIcon>{{ 'CODE' | translate}}</th>
                      <th [style]="{width:'35%'}" pSortableColumn="name">
                        <p-sortIcon field="name"></p-sortIcon>{{ 'NAME' | translate}}</th>
                      <th [style]="{width:'20%'}">{{ 'SEARCH_NAME' | translate}}</th>
                      <th [style]="{width:'20%'}" pSortableColumn="category.name">
                        <p-sortIcon field="category.name"></p-sortIcon>{{ 'MAIN_CATEGORY' | translate}}</th>
                      <th [style]="{width:'20%'}" pSortableColumn="category.name">
                        <p-sortIcon field="category.name"></p-sortIcon>{{ 'CATEGORY' | translate}}</th>
                      <th [style]="{width:'14%'}" pSortableColumn="totalCost">
                        <p-sortIcon field="totalCost"></p-sortIcon>{{ 'MIN_PRICE' | translate}}</th>
                      <th [style]="{width:'10%'}" pSortableColumn="totalCost">
                        <p-sortIcon field="totalCost"></p-sortIcon>{{ 'MAX_PRICE' | translate}}</th>
                      <th [style]="{width:'10%'}" pSortableColumn="totalCost">
                        <p-sortIcon field="totalCost"></p-sortIcon>{{ 'AVERAGE_PRICE' | translate}}</th>
                      <th [style]="{width:'8%'}">{{ 'UNIT' | translate}}</th>
                      <th [style]="{width:'15%'}">{{ 'ACTIONS' | translate}}</th>
                      <th [style]="{width:'11%'}">{{ '' | translate}}</th>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        <input (keydown.enter)="load()"  [ngModelOptions]="{ standalone: true }" pInputText [(ngModel)]="parameters.name">
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-product let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="product">
                      <td>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <input type="text"  [ngModelOptions]="{ standalone: true }" pInputText [(ngModel)]="product.code">
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{product.code}}
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <input type="text"  [ngModelOptions]="{ standalone: true }" pInputText [(ngModel)]="product.name">
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{product.name}}
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <input type="text"  [ngModelOptions]="{ standalone: true }" pInputText [(ngModel)]="product.searchName">
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{product.searchName}}
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <p-dropdown [options]="mainCategories" appendTo="body" filter="true" [ngModel]="product.mainCategory" [style]="{'width':'100%'}"
                            optionValue="@id" optionLabel="name" (onChange)="changeMainCategory($event,ri)" placeholder="{{'SELECT' | translate}}"
                            ></p-dropdown>
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{mainCategoriesNameArray[ri]}}
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <p-dropdown [options]="categories" appendTo="body" filter="true" [ngModel]="product.category" [style]="{'width':'100%'}"
                                        optionValue="@id" optionLabel="name" (onChange)="changeCategory($event,ri)" placeholder="{{'SELECT' | translate}}"
                            ></p-dropdown>
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{categoriesNameArray[ri]}}
                          </ng-template>
                        </p-cellEditor>

                      </td>
                      <td [style]="{textAlign:'right'}">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <input type="number" [ngModelOptions]="{ standalone: true }" pInputText [(ngModel)]="product.price">
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{product.price | countryCurrency}}
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td [style]="{textAlign:'right'}">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <input type="number" [ngModelOptions]="{ standalone: true }" pInputText [(ngModel)]="product.priceMax">
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{product.priceMax | countryCurrency}}
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td> {{(product.priceMax + product.price) / 2 | countryCurrency}}</td>
                      <td [style]="{textAlign:'right'}">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <input type="text"  [ngModelOptions]="{ standalone: true }" pInputText [(ngModel)]="product.unit">
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{product.unit}}
                          </ng-template>
                        </p-cellEditor>
                        </td>
                        <td>
                          <span style="display: flex; gap: 10px;">
                            <p-button label="" icon="pi pi-refresh" (onClick)="updatePrice(product)"></p-button>
                            <p-button label="" icon="pi pi-search" (onClick)="openSearchStocks(product)"></p-button>
                            <p-button label="" icon="pi pi-book" (onClick)="openInvoiceInQapera(product)"></p-button>
                          </span>
                        </td>

                      <td>
                        <div class="flex align-items-center justify-content-center gap-2">
                          <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="edit(product)" class="p-button-rounded p-button-text"></button>
                          <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="saveCookBookStock(product ,ri)"  class="p-button-rounded p-button-text p-button-success mr-2"></button>
                          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"  class="p-button-rounded p-button-text p-button-danger"></button>
                          <button *ngIf="!editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-trash" (click)="deleteCookBookStock(product ,ri)"  class="p-button-rounded p-button-text p-button-danger"></button>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-sidebar [(visible)]="searchStocks" position="right" [modal]="true" styleClass="p-sidebar-lg">
    <div class="p-grid">
      <div class="p-col-12" style="overflow-x: auto;">
        <div class="main-content-div">
          <div>
            <div class="main-content-div-row3">
              <div class="category-div">
                <div class="p-grid">
                  <form (ngSubmit)="updateSelectedStocks()">
                    <button type="submit" pButton label="{{'MATCHING' | translate}}" [style]="{marginBottom: '10px'}"></button>
                    <p-table [value]="stocks" dataKey="id" [(selection)]="selectedStocks" editMode="row">
                      <ng-template pTemplate="header">
                        <tr>
                          <th [style]="{width:'2%'}"  scope="row">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                          </th>
                          <th [style]="{width:'15%'}"  scope="row">{{ 'COMPANY_NAME' | translate }}</th>
                          <th [style]="{width:'20%'}"  scope="row">{{ 'NAME' | translate }}</th>
                          <th [style]="{width:'10%'}"  scope="row">{{ 'CATEGORY' | translate }}</th>
                          <th [style]="{width:'10%'}"  scope="row">{{ 'PRICE' | translate }}</th>
                          <th [style]="{width:'10%'}"  scope="row">{{ 'UNIT' | translate }}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-stock let-editing="editing" let-ri="rowIndex">
                        <tr [pEditableRow]="stock" [ngStyle]="{'background-color': stock.cookBookStock ? 'rgb(184 212 180 / 35%)' : 'transparent'}">
                          <td>
                            <p-tableCheckbox [value]="stock"></p-tableCheckbox>
                          </td>
                          <td>{{stock.company?.name}}</td>
                          <td>
                            <p-cellEditor>
                              <ng-template pTemplate="input">
                                <input type="text" [ngModelOptions]="{standalone: true}" pInputText [(ngModel)]="stock.name">
                              </ng-template>
                              <ng-template pTemplate="output">
                                {{stock.name}}
                              </ng-template>
                            </p-cellEditor>
                          </td>
                          <td>{{stock.category?.name}}</td>
                          <td [style]="{textAlign:'right'}">
                            {{stock.variants[0].price | countryCurrency}}
                          </td>
                          <td [style]="{textAlign:'right'}">
                            {{stock.unit?.name}}
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-sidebar>
  <p-sidebar [(visible)]="invoiceInQapera" position="right" [modal]="true" styleClass="p-sidebar-lg">
    <div class="p-grid">
      <div class="p-col-12" style="overflow-x: auto;">
        <div class="main-content-div">
          <div>
            <div class="main-content-div-row3">
              <div class="category-div">
                <div class="p-grid">
                  <div [style]="{margin: '10px 0', display: 'flex', gap: '10px' }">
                      <p-calendar dateFormat="yy-mm-dd" [showTime]="false"
                      [style]="{width: '100%', border: 'none'}" appendTo="body"
                      [(ngModel)]="date" (ngModelChange)="onSelectDate($event)"
                      placeholder="{{'SELECT_DATE'| translate}}">
                    </p-calendar>
                    <button type="submit" pButton label="{{'SEARCH' | translate}}" (click)="openInvoiceInQapera(product, date)"></button>
                  </div>

                    <p-table [value]="invoices" dataKey="id" editMode="row">
                      <ng-template pTemplate="header">
                        <tr>
                          <th [style]="{width:'15%'}" scope="row">{{ 'COMPANY_NAME' | translate }}</th>
                          <th [style]="{width:'20%'}"  scope="row">{{ 'SUPPLIER' | translate }}</th>
                          <th [style]="{width:'10%'}"  scope="row">{{ 'NAME' | translate }}</th>
                          <th [style]="{width:'10%'}"  scope="row">{{ 'TAX_AGENCY' | translate }}</th>
                          <th [style]="{width:'10%'}"  scope="row">{{ 'QUANTITY' | translate }}</th>
                          <th [style]="{width:'5%'}"  scope="row">{{ 'UNIT' | translate }}</th>
                          <th [style]="{width:'10%'}"  scope="row">{{ 'PRICE' | translate }}</th>
                          <th [style]="{width:'10%'}"  scope="row">{{ 'TOTAL' | translate }}</th>
                          <th [style]="{width:'10%'}"  scope="row">{{ 'DATE' | translate }}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-invoice>
                        <tr>
                          <td>{{invoice.companyName}} </td>
                          <td>{{invoice.contactName}}</td>
                          <td>{{invoice.stockName}}</td>
                          <td>{{invoice.taxAgency}}</td>
                          <td [style]="{textAlign:'right'}">{{invoice.quantity}}</td>
                          <td>{{invoice.unitName}}</td>
                          <td [style]="{textAlign:'right'}">{{invoice.unitPrice | currency: currencySymbol}}</td>
                          <td [style]="{textAlign:'right'}">{{invoice.total | currency: currencySymbol}}</td>
                          <td>{{ invoice.documentDate.date | date:'dd-MM-yyyy'}}</td>
                        </tr>
                      </ng-template>
                    </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-sidebar>

  <p-dialog title="{{ 'STOCK_IN_COOK_BOOK'| translate }}" [(visible)]="stockInCookBookDisplay" [style]="{width:'50vw'}" >
    <div class="dialogDiv">
      <div class="notification-main alert-div p-mb-6" style="display: flex;gap: 29px;align-items: center;">
        <div class="notification-icon">
          <i style="font-size: 40px;" class="pi pi-exclamation-triangle"></i>
        </div>
        <div class="notification-text">
          <b style="font-size: 18px;">{{ 'ALERT'  | translate}}</b><br>
          <span style="font-size: 16px;">{{ 'STOCK_IN_COOK_BOOK_ALERT' | translate}}</span>
        </div>
      </div>
      <p-table [value]="stockInCookBook" [tableStyle]="{'min-width': '50rem'}" [loading]="tableLoading">
        <ng-template pTemplate="header">
          <tr>
            <th [style]="{width:'85%'}" scope="row">{{ 'NAME' | translate}}</th>
            <th [style]="{width:'15%'}" scope="row">{{ 'QUANTITY' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-coockbok>
          <tr>
            <td>{{coockbok.cookBook?.name}} / {{coockbok.cookBook?.size}}</td>
            <td style="text-align: right">{{coockbok.amount}} {{ selectedStock?.unit}}</td>
          </tr>
        </ng-template>
      </p-table>
      <div class="p-mt-6">
        <hr>
      <h3>{{'SELECT_NEW_STOCK' | translate}}</h3>
        <p-autoComplete [(ngModel)]="newCookBookStock"
                        (onSelect)="onVariantSelect($event)"
                        field="name" [suggestions]="findCookBookStocks" appendTo="body"
                        (completeMethod)="searchVariant($event)">
        </p-autoComplete>
        <p-button label="{{'CHANGE_THIS_STOCK' | translate}}" (onClick)="changeStockInAllCookBook()" icon="pi pi-check"></p-button>
      </div>
    </div>
  </p-dialog>
</p-card>
